import { http } from './index';

//新建收藏夹
export const createFavorite = (params: {favoritesName:string}) => http.post('/teaching-workbench/favorites/api/created',params);

//修改收藏夹名称接口
export const updateFavorite = (params: { favoritesName:string,favoritesId:number|string}) => http.post('/teaching-workbench/favorites/api/update',params);

//获取收藏夹列表
export const getFavoriteList = () => http.get('/teaching-workbench/favorites/api/list');

//获取收藏问题列表接口
export const getQuestionList = (params: {content?:string,favoritesId?:number|string,pageNum?:number,pageSize?:number}) => http.get('/teaching-workbench/favorites/api/question-list',params);

//复制/移动问题到其他收藏夹
export const copyOrMoveQuestion = (params: {action:number, beforeFavoritesId:number|string,afterFavoritesId:number|string,questionIds:number []}) => http.post('/teaching-workbench/favorites/api/copy-or-move',params);

//根据id删除收藏夹及收藏夹下收藏内容
export const deleteFavorite = (id: number) => http.delete(`/teaching-workbench/favorites/api/favorites/${id}`);

//添加收藏接口
export const addQuestion = (params:{  questionId: number|string, favoritesId:string|number}) => http.post('/teaching-workbench/favorites/api/add-question',params);

//取消收藏接口
export const removeQuestions = (params:{ questionIds: number [], favoritesId?:number|string}) => http.post('/teaching-workbench/favorites/api/remove-questions',params);

